import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const crestWrapper = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: vars.space.xs,
  maxWidth: "150px",
});
